import { useZkStarter } from "@/components/apis/zkstarter";
import Image from "@/components/Image";
import { Modal } from "@/components/Modals/Modal";
import { useMemo } from "react";
import { Link } from "react-router-dom";

export function ModalZKStarter(props: { onClose: () => void }) {
  const { data } = useZkStarter();

  const roiHold = useMemo(() => {
    if (!data) {
      return "";
    }

    const i = data.find((e) => e.name === "Holdstation");
    return i?.athRoi || "--";
  }, [data]);

  const aaiRoi = useMemo(() => {
    if (!data) {
      return "";
    }

    const i = data.find((e) => e.name === "AutoAir AI");
    return i?.athRoi || "--";
  }, [data]);

  return (
    <Modal
      isOpen={true}
      position="right"
      onClose={() => {
        props.onClose();
      }}
    >
      <div className="flex flex-col gap-2 md:w-80 w-full px-2 py-5  pointer-events-auto">
        <div className="flex flex-col gap-4 p-5 rounded-3xl bg-white">
          <div className="flex gap-4 items-center flex-col md:flex-row">
            <Image
              src={require("@/assets/images/menu/ZKStarter.png")}
              className="w-20 h-20 md:w-12 md:h-12"
              width={400}
              height={400}
              alt="ZKStarter"
            />
            <p className="text-2xl font-medium text-black">zkStarter</p>
          </div>
          <Link
            to={"https://zkstarter.holdstation.com/"}
            target="_blank"
            className="hidden md:block bg-black w-full rounded-[90px] px-8 py-4 text-center"
          >
            <p className="text-base text-white font-medium">Launch App</p>
          </Link>
        </div>

        <div className="p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <p className="text-2xl text-[#777E90] font-medium">
            Offer promising and innovative projects a fast, secure, and
            efficient platform for decentralized fundraising
          </p>
        </div>

        <div className="flex gap-2">
          <div className="flex flex-col gap-[42px] p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC] basis-1/2">
            <div className="flex gap-2 items-center">
              <Image
                src={require("@/assets/images/logo_token_hs.png")}
                alt="holdstation"
                className="w-7 h-7"
                width={28}
                height={28}
              />
              <p className="text-2xl font-medium text-black">HOLD</p>
            </div>

            <div className="flex flex-col gap-2">
              <p className="text-base font-medium text-black">ATH Roi</p>
              <p className="text-2xl font-medium text-[#00A42F]">{roiHold}</p>
            </div>
          </div>
          <div className="flex flex-col gap-[42px] p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC] basis-1/2">
            <div className="flex gap-2 items-center">
              <Image
                src={require("@/assets/icons/ic_aai.png")}
                alt="AAI"
                className="w-7 h-7"
                width={84}
                height={84}
              />
              <p className="text-2xl font-medium text-black">AAI</p>
            </div>

            <div className="flex flex-col gap-2">
              <p className="text-base font-medium text-black">ATH Roi</p>
              <p className="text-2xl font-medium text-[#00A42F]">{aaiRoi}</p>
            </div>
          </div>
        </div>

        <div className="p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <p className="text-2xl font-medium text-black">Native on ZKsync</p>
          <Image
            alt="ZKsync"
            src={require("@/assets/svg/zksync.svg")}
            className="mx-auto mt-6 w-14 h-14"
            width={56}
            height={56}
          />
        </div>

        <Link
          data-action="redirect_zkstarter"
          to={"https://zkstarter.holdstation.com/"}
          target="_blank"
          className="fixed md:hidden bottom-10 bg-black w-fit min-w-44 rounded-[90px] px-8 py-4 left-1/2 transform -translate-x-1/2 text-center"
        >
          <p className="text-base text-white font-medium">Launch App</p>
        </Link>
      </div>
    </Modal>
  );
}
